import { connect } from 'react-redux'
import { makeLogicNodeSelector } from 'selectors/feature/logicNodes'
import { makeAffinityGroupSelector } from 'selectors/feature/affinityGroups'
import { getInDesignStatus } from 'selectors/feature/featureMetadata'
import { getValidationDescriptions } from 'selectors/feature/features'
import { toggleAffinityHighlight } from 'actions/feature/affinityGroups'
import { setQueryField } from 'actions/feature/queries'
import { deleteLogicNode, resetLogicNode } from 'actions/feature/logicNodes'
import { bindActionCreators } from 'redux'
import TimerBoxEditor from 'components/feature/TimerBoxEditor/TimerBoxEditor.jsx'
import { getIsSimulating, getIsEditing } from 'selectors/navigator'
import { getOrphanQueryUris } from 'selectors/feature/functionGraphs'
/*
Wrapping mapStateToProps in a make- function and sending that to connect
tells Redux that this gets evaluated only once per component instance,
and its returned value (the mapStateToprops fn) then is used to generate props to
pass into its child, like a normal mapStateToProps. This is needed so we
can have parameterized querySelector based on state and proper reselect memoization
with that.
*/
const makeMapStateToProps = () => {
  const timerSelector = makeLogicNodeSelector()
  const affinityGroupSelector = makeAffinityGroupSelector()

  const mapStateToProps = (state, ownProps) => {
    const { uri } = ownProps
    const { affinityGroupNumber, highlightAffinity } = affinityGroupSelector(
      state,
      { id: uri }
    )
    const timer = timerSelector(state, { queryUri: uri })
    const featureInDesign = getInDesignStatus(state)
    const allDescriptions = getValidationDescriptions(state)
    const isSimulating = getIsSimulating(state)
    const isEditing = getIsEditing(state)
    const orphanQueryUris = getOrphanQueryUris(state)
    const isOrphan = orphanQueryUris.includes(uri)
    const {
      description,
      timerMode,
      initialValue,
      enable,
      enableResult,
      reset,
      resetResult,
      refsFrom,
    } = timer

    return {
      timer,
      isOrphan,
      description,
      timerMode,
      initialValue,
      enable,
      enableResult,
      reset,
      resetResult,
      uri,
      refsFrom,
      affinityGroupNumber,
      highlightAffinity,
      featureInDesign,
      allDescriptions,
      isSimulating,
      isEditing,
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    {
      deleteLogicNode,
      resetLogicNode,
    },
    dispatch
  ),

  onCarryFromclick: () => dispatch(toggleAffinityHighlight(ownProps.uri)),

  updateDescription: (value) =>
    dispatch(setQueryField(ownProps.uri, 'description', value)),

  updateTimerMode: (event) =>
    dispatch(setQueryField(ownProps.uri, 'timerMode', event.target.value)),

  updateTimerValue: (value) =>
    dispatch(setQueryField(ownProps.uri, 'initialValue', value)),

  toggleMarkForDeletion: (toDelete) =>
    dispatch(setQueryField(ownProps.uri, 'markedForDeletion', toDelete)),
})

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  const { uri } = ownProps
  const {
    deleteLogicNode: deleteLogicNodeHandler,
    resetLogicNode: resetLogicNodeHandler,
    ...restFromDispatch
  } = propsFromDispatch
  const { timer, ...restFromState } = propsFromState
  const { markedForDeletion } = timer

  const deleteTimer = () => {
    deleteLogicNodeHandler(uri)
  }
  const resetTimer = () => {
    resetLogicNodeHandler(timer)
  }

  return {
    markedForDeletion,
    deleteTimer,
    resetTimer,
    ...timer,
    ...restFromDispatch,
    ...restFromState,
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(TimerBoxEditor)
